import { render } from "./EditSubjectPage.vue?vue&type=template&id=10092f13&scoped=true"
import script from "./EditSubjectPage.vue?vue&type=script&lang=js"
export * from "./EditSubjectPage.vue?vue&type=script&lang=js"

import "./EditSubjectPage.vue?vue&type=style&index=0&id=10092f13&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10092f13"]])

export default __exports__